import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages} from "../helpers/lazy-load";

let reclamsSliderBlocks = $('.js-reclams-slider-block')

if (reclamsSliderBlocks.length){
    reclamsSliderBlocks.each(function (){
        let block = $(this)

        let heroSwiper = new Swiper(block.find('.js-reclams-slider')[0], {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            //effect: "fade",
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: block.find(".js-reclams-slider-pagination")[0],
                clickable: true,
            },
            autoplay: {
                delay: 10000,
                disableOnInteraction: false
            },
            on: {
                slideChange: function (slider) {
                    if (slider.realIndex > 0) {
                        loadBlockLazyImages(reclamsSliderBlocks)
                    }
                },
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1,
                },
            },
        })

    })
}
